import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  useMemo,
} from "react";
import { Box, useMediaQuery, Alert, Link, useTheme } from "@mui/material";
import { MapContainer, TileLayer, useMap, useMapEvents } from "react-leaflet";
import ToolBarMaps from "../../../../../componentes/easyMaps/toolbarMapsPublicRp";
import L from "leaflet";
import "../../../../../componentes/leaflet-migrations";
import "../../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import "leaflet-routing-machine";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import RightBarEasyMaps from "../../../../../componentes/easyMaps/rightBarEasyMapsRP";
import TitleBar from "../../../../../componentes/easyMaps/titleBarPublic";
//import * as turf from "@turf/turf";
import ContextMenu from "../../../../../componentes/easyMaps/contextMenu";
import AlertModal from "../../../../../componentes/alertModal";
import DescriptionBar from "../../../../../componentes/easyMaps/descriptionBar";
import { useOutletContext } from "react-router-dom";
import RulerComponent from "../../../../../componentes/easyMaps/rulerPoints";
import useTextures from "./hooks/useTextures";
import PixiOverlay from "./pixiOverlayIcons";
import ClickDispatcher from "./components/clickDispatcher";
import { Close } from "@mui/icons-material";
import { PolylineCustom } from "./polyLine";

dayjs.extend(utc);
dayjs.extend(timezone);

const LeafletMapa = forwardRef((props, ref) => {
  const {
    title,
    setFullScreem,
    fullScreem,
    elements = [],
    connections = [],
    setElementSelected = () => {},
    setElementONUSelected = () => {},
    connectionSelected,
    setConnectionSelected = () => {},
    elementSelected,
    elementONUSelected,
    iconsElements = [],
    mapId,
    setConnections,
    setSnackbar,
    editMode,
    setEditMode,
    checkChanges,
    setCheckChanges,
    boundsCoordinates,
    centerCoordinates = [-10, -48],
    initialZoom,
    isDateRecent = true,
    collapse,
  } = props;

  const [lockMode, setLockMode] = useState(false);
  const [showLabel, setShowLabel] = useState(false);
  const [zoomIcons, setZoomIcons] = useState(5);
  const [contextMenu, setContextMenu] = useState(null);
  const [elementsConnected, setElementsConnected] = useState([]);
  const [elementsONUs, setElementsONUs] = useState([]);
  const [openRightBar, setOpenRightBar] = useState(false);
  const [contextMenuFlow, setContextMenuFlow] = useState(null);
  const [openAlertModal, setOpenAlertModal] = useState(null);
  const [openConnection, setOpenConnection] = useState(null);
  const [showLabelEnlace, setShowLabelEnlace] = useState(true);
  const [rulerMode, setRulerMode] = useState(false);
  const [rulerPoint, setRulerPoint] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(!isDateRecent);
  const mapRef = useRef(null);
  const didSetInitialZoom = useRef(false);
  const theme = useTheme();
  const { config, configLocal, setConfigLocal, configLayer } =
    useOutletContext();
  const shouldGetZoomRef = useRef(false);

  const isSm = useMediaQuery(theme.breakpoints.down("lg"));
  // useEffect(() => {
  //   if (!elements) return;

  const [markers, setMarkers] = useState([]);

  const [currentClusters, setCurrentClusters] = useState([]);

  /* ---------- MEMO ---------- */

  function colorEnlace(power) {
    if (power == null || power == 0 || power === Infinity || !config) {
      return theme.palette.enlaces.offline.main;
    }
    const result = config?.escalas?.ftth
      .filter((scale) => parseFloat(scale?.label) >= power)
      .pop();

    if (!result) return theme.palette.enlaces.offline.main;
    return result?.cor;
  }

  useEffect(() => {
    const ftthEscalaNum = (config?.escalas?.ftth ?? [])
      .map((e) => parseFloat(e?.label))
      .filter(Number.isFinite)
      .sort((a, b) => a - b);

    const selected = new Set(
      (Array.isArray(configLocal?.ftth?.filtroPotencia)
        ? configLocal?.ftth?.filtroPotencia
        : []
      ).map((v) => String(v))
    );

    const bucketLabel = (p) => {
      const rx = Number.parseFloat(p);
      if (!Number.isFinite(rx) || ftthEscalaNum.length === 0)
        return "Sem Dados";

      const topo = ftthEscalaNum[ftthEscalaNum.length - 1];
      if (rx > topo) return "Sem Dados";

      const idx = ftthEscalaNum.findIndex((c) => c >= rx);
      const ceil = idx >= 0 ? ftthEscalaNum[idx] : topo;
      return String(ceil);
    };

    const mks = elements.map((element) => ({
      ...element,
      position: [
        parseFloat(element?.elementConfig?.config?.coordenadas?.lat),
        parseFloat(element?.elementConfig?.config?.coordenadas?.long),
      ],
      iconId: ["cto"],
      baseIcon: ["cto"],
      tint: colorEnlace(element?.data?.potencia?.rx),
      label: element.titulo ?? element.id,
    }));

    const filteredMks = mks.filter((m) => {
      if (selected.size === 0) return true;
      const label = bucketLabel(m?.data?.potencia?.rx);
      return selected.has(label);
    });

    setMarkers(filteredMks);
  }, [elements, config, configLocal?.ftth?.filtroPotencia]);

  useEffect(() => {
    setSnackbarOpen(!isDateRecent);
  }, [isDateRecent]);

  const allMarkers = useMemo(
    () => [...markers, ...elementsONUs],
    [markers, elementsONUs]
  );

  const handleClick = useCallback(
    (id) => {
      const found = allMarkers.find((el) => el.id === id);
      if (found) {
        found.iconId[0] === "cto"
          ? setElementSelected(found)
          : setElementONUSelected(found);
      }
    },
    [allMarkers, setElementSelected]
  );
  const handleBackgroundClick = useCallback(() => {
    setElementSelected(null);
    setElementsONUs([]);
    setElementONUSelected(null);
  });
  const handleClusterClick = useCallback((cluster) => {
    if (!mapRef.current) return;

    // Zoom into the cluster
    const map = mapRef.current;
    const currentZoom = map.getZoom();
    const newZoom = Math.min(currentZoom + 2, 19);

    map.setView(L.latLng(cluster.center), newZoom);
  }, []);
  /* ---------- TEXTURAS ---------- */
  const texturesReady = useTextures();

  //===============================================================

  useEffect(() => {
    setTimeout(() => {
      if (mapRef.current && mapRef.current.invalidateSize) {
        mapRef.current.invalidateSize();
      }
    }, 300);
  }, [collapse]);

  useEffect(() => {
    if (!mapRef.current) return;
    let size = map_range(mapRef.current.getZoom(), 0, 15, 2, 7);
    setZoomIcons(size);
    SetMaxBounds();
    mapRef.current.invalidateSize();
  }, [mapRef.current]);

  useEffect(() => {
    if (!rulerMode) return;

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "z") {
        e.preventDefault();
        removeLastEl();
      }
    };

    const handleMouseClick = (e) => {
      if (e.button === 2) {
        e.preventDefault();
        removeLastEl();
      }
    };

    const handleContextMenu = (e) => {
      if (rulerMode) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousedown", handleMouseClick);
    window.addEventListener("contextmenu", handleContextMenu);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousedown", handleMouseClick);
      window.removeEventListener("contextmenu", handleContextMenu);
    };
  }, [rulerMode]);

  useEffect(() => {
    if (!elementSelected?.id) setElementSelected(null);
    if (editMode == false) {
      setElementSelected((data) => elements.find((e) => e?.id == data?.id));
    }

    setConnectionSelected(null);
    setElementsConnected(null);
  }, [editMode, showLabel]);

  useEffect(() => {
    if (!elementSelected?.id) {
      setElementsONUs([]);
      setElementONUSelected(null);
      return;
    }
    const offline = config?.escalas?.ftth.filter(
      (c) => c.label === "Sem Dados"
    );

    let cood = elementSelected?.elementConfig?.config?.coordenadas;
    if (cood.lat != null && cood.long != null)
      focusZoomCoordenates(cood.lat, cood.long); // precisava ser mais rapido por isso não usei focusZoom()

    const formatElementsClients = elementSelected.elementsClients.map(
      (client, idx) => {
        const rxClient = client?.data?.potencia?.rx;
        // formata os dados para as onus
        return {
          ...client,
          position: [
            parseFloat(client?.elementConfig.config.coordenadas.lat),
            parseFloat(client?.elementConfig.config.coordenadas.long),
          ],
          iconId: ["house"],
          baseIcon: ["house"],
          tint: colorEnlace(rxClient),
          label: client.titulo ?? client.id ?? idx,
        };
      }
    );
    const filteredElementsONUs = !configLocal?.ftth?.noDataElements
      ? formatElementsClients.filter((m) => m.tint !== offline[0].cor)
      : formatElementsClients;
    setElementsONUs(filteredElementsONUs);
  }, [elementSelected, configLocal?.ftth?.noDataElements]);

  useEffect(() => {
    if (!elementONUSelected) return;
    let cood = elementONUSelected?.elementConfig?.config?.coordenadas;
    if (cood.lat != null && cood.long != null)
      focusZoomCoordenates(cood.lat, cood.long); // precisava ser mais rapido por isso não usei focusZoom()
  }, [elementONUSelected]);

  const SetMaxBounds = () => {
    if (!mapRef.current) return;

    var southWest = L.latLng(-89.98155760646617, -180),
      northEast = L.latLng(89.99346179538875, 180);
    var bounds = L.latLngBounds(southWest, northEast);

    mapRef.current.setMaxBounds(bounds);

    return null;
  };

  const clearRuler = () => {
    setRulerPoint([]);
    setRulerMode(false);
  };

  const removeLast = () => {
    setRulerPoint((prev) => {
      if (prev.length === 0) return prev;
      return prev.slice(0, -2);
    });
  };

  const removeLastEl = () => {
    setRulerPoint((prev) => {
      if (prev.length === 0) return prev;
      return prev.slice(0, -1);
    });
  };

  const styles = {
    paperContainer: {
      padding: "16px ",
      display: "flex",
      alignItems: "center",
      position: "relative",
      width: "100%",
      borderRadius: 3,
      mt: 5.5,
    },
    body: {
      width: "100%",
      height: "100%",
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      left: "0px",
      top: "0px",
      //zIndex: 0,
      overflow: "hidden",
    },

    mapInfoStack: {
      padding: "12px 16px",
      width: "250px",
    },
    mapInfoDataStack: {
      padding: "12px 16px",
      width: "120px",
    },
    mapInfoTitle: {
      fontSize: "0.75rem",
      lineHeight: 1.25,
      fontWeight: 600,
      letterSpacing: "0.033em",
      color: "primary.main",
    },
    mapInfoText: {
      fontSize: "0.875rem",
      lineHeight: 1.5,
      fontWeight: 400,
      textTransform: "capitalize",
    },
    fontPopup: {
      margin: "0px",
      fontSize: "10px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
    },
    titlePopup: {
      margin: "0px",
      fontSize: "12px",
      fontWeight: 500,
      color: theme.palette.color.textEasyMaps,
      width: "100%",
      textAlign: "center",
      marginBottom: "10px",
      whiteSpace: "normal",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitLineClamp: 2, // Limite de 2 linhas
      WebkitBoxOrient: "vertical",
    },
  };

  const formatPoints = (element) => {
    let nodeStart = null,
      nodeEnd = null;

    if (element.referenceId == elementSelected?.id) nodeStart = elementSelected;
    else
      nodeStart = [...elements, ...elementsONUs].find(
        (node) => node.id == element.referenceId
      );

    if (element.destinationId == elementSelected?.id) nodeEnd = elementSelected;
    else
      nodeEnd = [...elements, ...elementsONUs].find(
        (node) => node.id == element.destinationId
      );

    let nodeStartPosition = {
      lat: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeStart?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };
    let nodeEndPosition = {
      lat: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.lat),
      long: parseFloat(nodeEnd?.elementConfig?.config?.coordenadas?.long),
      active: false,
    };

    let points = [
      nodeStartPosition,
      ...(element.positionHandlers ?? []).map((a) => ({
        lat: a.y,
        long: a.x,
        active: false,
      })),
      nodeEndPosition,
    ];

    return points;
  };

  useImperativeHandle(ref, () => ({
    focusZoomExt(id) {
      if (!id) return;
      let element = elements.find((e) => e.id == id);
      if (element) {
        shouldGetZoomRef.current = true;

        setElementSelected(element);
      } else {
        element = elements.find(
          (e) => !!e.elementsClients.find((client) => client.id == id)
        );
        if (!element) return;
        shouldGetZoomRef.current = true;
        setElementSelected(element);
        setElementONUSelected(
          element?.elementsClients.find((client) => client.id == id)
        );
      }
    },
  }));

  function map_range(value, low1, high1, low2, high2) {
    return parseInt(low2 + ((high2 - low2) * (value - low1)) / (high1 - low1));
  }

  function zoom(action) {
    if (!mapRef.current) return;
    const map = mapRef.current;
    let zoom = map.getZoom();
    // garante que o mapa não fique deslizando
    if (zoom > 19 && action > 0) return;
    if (zoom < 1 && action < 0) return;
    map.setZoom(zoom + action);
  }
  function focusZoom(id) {
    if (!id) return;
    let element = elements.find((e) => e.id == id);
    if (!element) {
      element = elementsONUs.find((e) => e.id == id);
    }
    if (!element) return;
    let cood = element.elementConfig.config.coordenadas;
    if (cood.lat != null && cood.long != null)
      focusZoomCoordenates(cood.lat, cood.long);
  }

  function focusZoomCoordenates(lat, lng) {
    const forceZoom = shouldGetZoomRef.current;

    if (lat == null || lng == null) return;
    const map = mapRef.current;
    if (!elementSelected)
      forceZoom ? map?.setView([lat, lng], 18) : map?.setView([lat, lng]);
    else
      forceZoom
        ? map?.setView([lat, parseFloat(lng) + 0.0003], 18)
        : map?.setView([lat, parseFloat(lng) + 0.0003]);
    shouldGetZoomRef.current = false;
  }
  const onNodeClick = (event, node) => {
    setConnectionSelected(null);
    setOpenConnection(null);

    if (node?.id === elementSelected?.id) {
      setElementSelected(null);
      setElementsONUs([]);
      setElementONUSelected(null);
      return;
    }

    setElementSelected(JSON.parse(JSON.stringify(node)));
    setElementONUSelected(null);

    if (!editMode) {
      const selected = node;
      let idsElements = [selected?.id];
      let idsConnections = [];
      let elementsConnect = [];

      connections.forEach(({ referenceId, destinationId, id }) => {
        if (node?.id === destinationId || node?.id === referenceId) {
          const findElement = elements?.find(
            ({ id }) =>
              id === (node?.id === destinationId ? referenceId : destinationId)
          );
          elementsConnect.push(findElement);
          idsElements.push(findElement?.id);
          idsConnections.push(id);
        }
      });
      setElementSelected(JSON.parse(JSON.stringify(selected)));
      setElementsConnected(elementsConnect);
      setOpenRightBar(true);
    }
  };

  const onNodeContextMenu = useCallback(
    (event, node) => {
      //event.preventDefault();
      if (editMode) {
        setContextMenu(
          contextMenu === null
            ? {
                id: node.id,
                top: event.containerPoint.y + 60,
                left: event.containerPoint.x + 310,
                node,
              }
            : null
        );
      }
    },
    [setContextMenu, editMode]
  );

  // const updateEdgeEnd = (index, edgeUpdate) => {
  //   setCheckChanges(true);
  //   setConnectionSelected((data) => {
  //     data.positionHandlers[index] = edgeUpdate;
  //     return { ...data };
  //   });
  // };
  // const removeEdge = (index) => {
  //   setConnectionSelected((data) => {
  //     data.positionHandlers.splice(index, 1);
  //     return { ...data };
  //   });
  // };
  // function keepOnlyLastCall(fn, delay) {
  //   return function (...args) {
  //     if (timer.current) {
  //       clearTimeout(timer.current);
  //     } // Limpa o timeout anterior
  //     timer.current = setTimeout(() => fn(...args), delay); // Define um novo timeout
  //   };
  // }
  //const handleDragWithLastOnly = keepOnlyLastCall(visibleItems, 17); // Executa apenas a última após 20ms

  function Events() {
    const map = useMap();
    const moveTimeout = useRef();
    useMapEvents({
      click(e) {
        if (rulerMode) {
          setRulerPoint((prev) => [...prev, e.latlng]);
        }
      },
      move(e) {
        if (moveTimeout.current) clearTimeout(moveTimeout.current);
        moveTimeout.current = setTimeout(() => {
          const center = map.getBounds().getCenter();
          const zoom = map.getZoom();
          const url = new URL(window.location.href);
          url.searchParams.set("lat", center.lat);
          url.searchParams.set("lng", center.lng);
          url.searchParams.set("zoom", zoom);
          window.history.replaceState({}, "", url);
        }, 200);
      },
    });
    return null;
  }

  const SetInitialZoom = () => {
    const map = useMap();
    useEffect(() => {
      if (!map || didSetInitialZoom.current) return;
      if (initialZoom && centerCoordinates) {
        didSetInitialZoom.current = true;
        return;
      }
      if (Array.isArray(boundsCoordinates) && boundsCoordinates) {
        const dataBounds = L.latLngBounds(boundsCoordinates);

        map.fitBounds(dataBounds, {
          maxZoom: 14,
        });
        didSetInitialZoom.current = true;

        const centerInPx = map.latLngToContainerPoint(centerCoordinates);
        const newCenterInPx = { ...centerInPx, x: centerInPx.x - 50 };
        const newCenterInCoords = map.containerPointToLatLng(newCenterInPx);

        map.setView(newCenterInCoords);
      }
    }, [map]);

    return null;
  };

  return (
    <>
      <Box sx={{ overflow: "visible", zIndex: 1202 }}>
        {!isSm && (
          <TitleBar
            title={title}
            id={mapId}
            setSnackbar={setSnackbar}
            center={elementSelected != null || connectionSelected != null}
          />
        )}
      </Box>
      <Box sx={styles.body}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            marginTop: { xs: 5, sm: 0 },
          }}
        >
          {snackbarOpen && (
            <Box
              sx={{
                position: "absolute",
                borderRadius: 2,
                width: { xs: "%100", sm: "calc(100vw - 278px)" },
                ml: { xs: "22vw", lg: "150px" },
                py: 2,
                zIndex: 2,
                display: "flex",
                justifyContent: "center",
                gap: 1.5,
              }}
            >
              <Alert
                severity="warning"
                onClose={() => setSnackbarOpen(false)}
                action={
                  <Close
                    fontSize="small"
                    onClick={() => setSnackbarOpen(false)}
                    sx={{ cursor: "pointer" }}
                  />
                }
                sx={{
                  alignItems: "center",

                  width: {
                    xs: "80vw",
                    xsm: "300px",
                    sm: "300px",
                    md: "300px",
                    mdl: "300px",
                    lg: "400px",
                    xl: "635px",
                  },
                }}
              >
                Os dados do mapa estão desatualizados. Por favor, entre em{" "}
                <Link
                  href="https://wa.me/5584994581475"
                  color={theme.palette.warning.main}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  contato com o suporte.
                </Link>
              </Alert>
            </Box>
          )}

          <ToolBarMaps
            setEasyMapsConfig={setConfigLocal}
            easyMapsConfig={configLocal}
            config={config}
            editMode={editMode}
            setEditMode={setEditMode}
            fullScreem={fullScreem}
            setFullScreem={setFullScreem}
            showLabel={showLabel}
            setShowLabel={setShowLabel}
            lockMode={lockMode}
            setLockMode={setLockMode}
            setShowLabelEnlace={setShowLabelEnlace}
            showLabelEnlace={showLabelEnlace}
            setOpenAlertModal={setOpenAlertModal}
            checkChanges={checkChanges}
            setShowRuler={setRulerMode}
            setRulerPoint={setRulerPoint}
            showRuler={rulerMode}
            tipo={0}
            isFtth={true}
          >
            <ToolBarMaps.InputZoomGeo zoom={zoom} />
          </ToolBarMaps>

          {!editMode && (
            <DescriptionBar
              key={"descrptionbar"}
              variant="ftth"
              elementSelected={!!elementSelected}
              layer={configLayer?.[mapId] || "trafego"}
            />
          )}

          <MapContainer
            //maxBoundsViscosity={1}
            //worldCopyJump={true}
            fullscreenControl={false}
            ref={mapRef}
            key={`mapaSingle`}
            id="map"
            center={centerCoordinates}
            zoom={initialZoom ?? 4}
            // inertia={true}
            // boxZoom={true}
            minZoom={3}
            // maxZoom={19}
            // fadeAnimation={false}
            // zoomControl={false}
            // easeLinearity={0.6}
            // doubleClickZoom={false}
            //  enableHighAccuracy={true}
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 0,
            }}
          >
            <TileLayer
              url={
                theme.palette.mode == "dark"
                  ? config?.mapaTile?.dark ||
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  : config?.mapaTile?.light ||
                    "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              }
              //url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
              //url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              maxZoom={19}
              detectRetina={true}
              //url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
              //satelite
              //url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              //attribution="&copy; OpenStreetMap contributors"
            />
            <Events />
            {rulerMode && (
              <RulerComponent
                rulerPoints={rulerPoint}
                removeLast={removeLast}
                onClearRuler={clearRuler}
              />
            )}
            <SetInitialZoom />
            {/* {allMarkers.length > 0 && (
              <ClickDispatcher
                markers={allMarkers}
                clusters={currentClusters}
                enableClustering={mapRef?.current?.getZoom() <= 17}
                onClick={handleClick}
                onBackgroundClick={handleBackgroundClick}
                onClusterClick={handleClusterClick}
              />
            )} */}
            {texturesReady && (
              <PixiOverlay
                markers={markers}
                elementsONUS={elementsONUs}
                enableClustering={mapRef?.current?.getZoom() <= 17}
                onClustersChange={setCurrentClusters}
                onClick={handleClick}
                onBackgroundClick={handleBackgroundClick}
                onClusterClick={handleClusterClick}
                elementSelected={elementSelected}
                elementONUSelected={elementONUSelected}
              />
            )}
            {elementSelected &&
              connections
                .filter((conn) => {
                  const onu = elementsONUs.find(
                    (ele) => ele.id === conn.destinationId
                  );

                  return (
                    conn.referenceId === elementSelected.id &&
                    onu &&
                    onu.elementConfig?.config?.coordenadas?.lat != null &&
                    onu.elementConfig?.config?.coordenadas?.long != null
                  );
                })
                .map((conn, index) => {
                  let position = formatPoints(conn);
                  if (!editMode) {
                    let destination = elementSelected.elementsClients.find(
                      (a) => a.id == conn.destinationId
                    );

                    return (
                      <PolylineCustom
                        darkMode={theme.palette.mode == "dark"}
                        configLocal={configLocal}
                        variant="ftth"
                        percent={destination?.data?.potencia?.rx}
                        host={
                          [...elementSelected.elementsClients].find(
                            (ele) => ele.id == conn.destinationId
                          )?.titulo
                        }
                        data={{
                          ...conn?.data,
                          powerRx: destination?.data?.potencia?.rx,
                          powerTx: destination?.data?.potencia?.tx,
                        }}
                        isDown={!!!destination?.data?.status.value}
                        key={conn.id + "selected" + index}
                        positions={position.map((a) => [
                          a.lat || 0,
                          a.long || 0,
                        ])}
                        animation={"pontilhada"}
                        onClick={(e) => {
                          L.DomEvent.stopPropagation(e);
                          let elemento = elementsONUs.find(
                            (ele) => ele.id == conn.destinationId
                          );
                          setElementONUSelected(elemento);
                          setOpenConnection(elemento.id);
                        }}
                      />
                    );
                  }
                })}
          </MapContainer>

          <RightBarEasyMaps
            mapId={mapId}
            setElementONUSelected={setElementONUSelected}
            elementONUSelected={elementONUSelected}
            setFocusNodeId={focusZoom}
            open={openRightBar}
            setOpen={setOpenRightBar}
            elements={elements}
            //connections={elementsConnected}
            connections={connections}
            setElement={setElementSelected}
            setConnections={setElementsConnected}
            iconsElement={iconsElements}
            element={!editMode && elementSelected?.id ? elementSelected : null}
            fullScreem={fullScreem}
            openConnection={openConnection}
            setOpenConnection={setOpenConnection}
            link={`/easyMaps/mapa/${
              elementSelected?.mapRef?.tipo === 0 ? "geo" : "top"
            }/${elementSelected?.mapRefId ?? ""}`}
          />
        </Box>

        <ContextMenu
          contextMenu={contextMenuFlow}
          setContextMenu={setContextMenuFlow}
          editMode={editMode}
          setEditMode={setEditMode}
        />

        <AlertModal
          openModal={openAlertModal?.open ?? false}
          setOpenModal={(data) => setOpenAlertModal({ open: data })}
          buttonText={openAlertModal?.buttonText}
          buttonCancelText={openAlertModal?.buttonCancelText}
          confirmar={false}
          handleButton={() => {
            setCheckChanges(false);
            setOpenAlertModal({ open: false });
            if (openAlertModal.callback) {
              openAlertModal.callback(...(openAlertModal?.params || []));
              return;
            }
            setElementSelected(null);
            setElementONUSelected(null);
            setConnectionSelected(null);
          }}
          severity={openAlertModal?.severity}
          singleButton={false}
          textContent={openAlertModal?.text}
        />
      </Box>
    </>
  );
});

export default LeafletMapa;
